import type { QuoteTaskDetailPublic } from "@common/client"

export function partsRollup(
  task: QuoteTaskDetailPublic,
): QuoteTaskDetailPublic["active_charges"][number] | null {
  const rollup = task.active_charges.find(
    (charge) => charge.type === "part_flat_rate",
  )
  return rollup ?? null
}

export function totalCharges(
  task: QuoteTaskDetailPublic,
): QuoteTaskDetailPublic["active_charges"] {
  return partsRollup(task) === null
    ? task.active_charges
    : task.active_charges.filter((charge) => charge.type !== "part")
}

function byPartNumber(a: string | null, b: string | null): number {
  if (a === null) return b === null ? 0 : 1
  if (b === null) return -1
  return a.localeCompare(b, undefined, { numeric: true })
}

export function partCharges(
  task: QuoteTaskDetailPublic,
): QuoteTaskDetailPublic["active_charges"] {
  return task.active_charges
    .filter((charge) => charge.type === "part")
    .sort((left, right) => byPartNumber(left.part_number, right.part_number))
}
